<script lang="ts">
    import { Switch, Radio, Icon } from 'svelte-materialify';
    import { mdiAlertBoxOutline } from '@mdi/js';

    // props
    export let recordHand: string;
    export let hamster: boolean;


    // radioBtn group _has_ to have "group" variable :/
    let group = recordHand;
    $: recordHand = group;

</script>

<style>
.row { 
    margin-bottom: 15px;
}
.row:last-of-type { margin-bottom: 0; }
</style>

<div>

    <div class="row">
        Record hand            
        <Radio bind:group value={'left'}>left</Radio>
        <Radio bind:group value={'right'}>right</Radio>
    </div>

    <div class="row">
        <Switch bind:checked={hamster}>
            Hamster Mode
        </Switch>
    </div>

    <div style="margin-top: 20px;">
        <Icon path={mdiAlertBoxOutline} />
        Crossfader movement still buggy!
    </div>

</div>